// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Section{flex-grow:1;flex-basis:0;min-width:500px;position:relative}
`, "",{"version":3,"sources":["webpack://./src/equipment/details/new_settings/components/Section.scss"],"names":[],"mappings":"AACA,SACE,WAAY,CACZ,YAAa,CACb,eAAgB,CAChB,iBAAkB","sourcesContent":["\n.Section {\n  flex-grow: 1;\n  flex-basis: 0;\n  min-width: 500px;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
